export default __webpack_public_path__ + "static/media/all_services_icon.ce62e108.svg";